/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdWebFeaturesGamesChooseGameRequestToJSON, FxIdWebFeaturesGamesChooseGameResponseFromJSON, FxIdWebFeaturesPlayGameResponseFromJSON, FxIdWebFeaturesPlayListResponseFromJSON, } from '../models/index';
/**
 *
 */
export class PlayApi extends runtime.BaseAPI {
    /**
     * ВНИМАНИЕ! Этот код ТЕСНО связан с: 1. конфигом нжиникса (тот должен присылать original_path) 2. политикой кеширования в ConfigureWebServicesExtension (он парсит так же как GetGameByHttpRequestHandler выискивая игру в original_path) 3. роутингом на клиенте (он должен пробовать запускать игры по /play/{game} 4. кодом в GetGameByHttpRequestHandler (он должен парсить /play так же как политика)
     */
    async fxIdWebFeaturesGamesChooseGameEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesGamesChooseGameRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesGamesChooseGameRequest', 'Required parameter "fxIdWebFeaturesGamesChooseGameRequest" was null or undefined when calling fxIdWebFeaturesGamesChooseGameEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/play/choose_game`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesGamesChooseGameRequestToJSON(requestParameters['fxIdWebFeaturesGamesChooseGameRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesGamesChooseGameResponseFromJSON(jsonValue));
    }
    /**
     * ВНИМАНИЕ! Этот код ТЕСНО связан с: 1. конфигом нжиникса (тот должен присылать original_path) 2. политикой кеширования в ConfigureWebServicesExtension (он парсит так же как GetGameByHttpRequestHandler выискивая игру в original_path) 3. роутингом на клиенте (он должен пробовать запускать игры по /play/{game} 4. кодом в GetGameByHttpRequestHandler (он должен парсить /play так же как политика)
     */
    async fxIdWebFeaturesGamesChooseGameEndpoint(fxIdWebFeaturesGamesChooseGameRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesGamesChooseGameEndpointRaw({ fxIdWebFeaturesGamesChooseGameRequest: fxIdWebFeaturesGamesChooseGameRequest }, initOverrides);
        return await response.value();
    }
    /**
     * ВНИМАНИЕ! Этот код ТЕСНО связан с: 1. конфигом нжиникса (тот должен присылать original_path) 2. политикой кеширования в ConfigureWebServicesExtension (он парсит так же как GetGameByHttpRequestHandler выискивая игру в original_path) 3. роутингом на клиенте (он должен пробовать запускать игры по /play/{game} 4. кодом в GetGameByHttpRequestHandler (он должен парсить /play так же как политика)
     */
    async fxIdWebFeaturesGamesIndexIndexEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/play/index_html`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * ВНИМАНИЕ! Этот код ТЕСНО связан с: 1. конфигом нжиникса (тот должен присылать original_path) 2. политикой кеширования в ConfigureWebServicesExtension (он парсит так же как GetGameByHttpRequestHandler выискивая игру в original_path) 3. роутингом на клиенте (он должен пробовать запускать игры по /play/{game} 4. кодом в GetGameByHttpRequestHandler (он должен парсить /play так же как политика)
     */
    async fxIdWebFeaturesGamesIndexIndexEndpoint(initOverrides) {
        await this.fxIdWebFeaturesGamesIndexIndexEndpointRaw(initOverrides);
    }
    /**
     */
    async fxIdWebFeaturesPlayGameEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesPlayGameEndpoint().');
        }
        if (requestParameters['otaVersion'] == null) {
            throw new runtime.RequiredError('otaVersion', 'Required parameter "otaVersion" was null or undefined when calling fxIdWebFeaturesPlayGameEndpoint().');
        }
        if (requestParameters['buildNumber'] == null) {
            throw new runtime.RequiredError('buildNumber', 'Required parameter "buildNumber" was null or undefined when calling fxIdWebFeaturesPlayGameEndpoint().');
        }
        if (requestParameters['webPublishingPlatform'] == null) {
            throw new runtime.RequiredError('webPublishingPlatform', 'Required parameter "webPublishingPlatform" was null or undefined when calling fxIdWebFeaturesPlayGameEndpoint().');
        }
        const queryParameters = {};
        if (requestParameters['otaVersion'] != null) {
            queryParameters['OtaVersion'] = requestParameters['otaVersion'];
        }
        if (requestParameters['buildNumber'] != null) {
            queryParameters['BuildNumber'] = requestParameters['buildNumber'];
        }
        if (requestParameters['webPublishingPlatform'] != null) {
            queryParameters['WebPublishingPlatform'] = requestParameters['webPublishingPlatform'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/play/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesPlayGameResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesPlayGameEndpoint(game, otaVersion, buildNumber, webPublishingPlatform, initOverrides) {
        const response = await this.fxIdWebFeaturesPlayGameEndpointRaw({ game: game, otaVersion: otaVersion, buildNumber: buildNumber, webPublishingPlatform: webPublishingPlatform }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesPlayListEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesPlayListEndpoint().');
        }
        if (requestParameters['otaVersion'] == null) {
            throw new runtime.RequiredError('otaVersion', 'Required parameter "otaVersion" was null or undefined when calling fxIdWebFeaturesPlayListEndpoint().');
        }
        const queryParameters = {};
        if (requestParameters['otaVersion'] != null) {
            queryParameters['OtaVersion'] = requestParameters['otaVersion'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/play/{Game}/list`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesPlayListResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesPlayListEndpoint(game, otaVersion, initOverrides) {
        const response = await this.fxIdWebFeaturesPlayListEndpointRaw({ game: game, otaVersion: otaVersion }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=PlayApi.js.map